import { useCallback } from 'react';
import type { GoodsDetailTab } from '../types/GoodsDetailTab';
import { useLogGoodsAnalyticsEvent } from './useLogGoodsAnalyticsEvent';

export const useLogClickGoodsDetailTab = () => {
  const logGoodsAnalytics = useLogGoodsAnalyticsEvent();

  return useCallback<(tab: GoodsDetailTab) => void>(
    tab => {
      logGoodsAnalytics({
        name: 'CLICK_GOODS_DETAIL_TAB',
        analytics: {
          TAB: tab,
        },
      });
    },
    [logGoodsAnalytics],
  );
};
